import React, {Component} from 'react';
import axios from "axios";
import Button from "react-bootstrap/Button";

import classes from'./NewPublisher.module.css';
import Form from "react-bootstrap/Form";
import apiUrl from "../../../shared/config";

class NewPublisher extends Component  {
    state = {
        publishers: [],
        game_publisher: {
            game_publisher_id: null,
            game_publisher_name: '',
            game_publisher_notes: ''
        }
    };

    componentDidMount() {
        if (this.props.publishers !== []) {
            this.setState({publishers: this.props.publishers});
        }
    }

    addHandler = () => {
        this.postDataHandler(null);
        this.props.newPublisherToggle();
    };

    postDataHandler = () => {
        const post = {
            "game_publisher_id": this.state.game_publisher.game_publisher_id,
            "game_publisher_name": this.state.game_publisher.game_publisher_name,
            "game_publisher_notes": this.state.game_publisher.game_publisher_notes,
        };
        axios.post(apiUrl +'Publishers/set', post)
            .then(response => {
                this.props.onNewPublisher(response.data);
            });
        this.setState({
            "game_publisher": {
                game_publisher_id: null,
                game_publisher_name: '',
                game_publisher_notes: ''
            }
        });

    };

    render() {
        return (
            <>
                <dd className={"col-sm-9"}>
                    <div className={classes.NewPublishersBlock}>
                        <div>
                            <Form.Control
                                type="text"
                                placeholder="Enter the name of the publisher you want to create."
                                value={this.state.game_publisher.game_publisher_name}
                                onChange={(event) => this.setState({game_publisher: {...this.state.game_publisher, game_publisher_name: event.target.value}})}
                            />
                            <Form.Control
                                as="textarea"
                                rows="4"
                                placeholder="Include a paragraph or so long description of the publisher."
                                value={this.state.game_publisher.game_publisher_notes}
                                onChange={(event) => this.setState({game_publisher: {...this.state.game_publisher, game_publisher_notes: event.target.value}})}
                            />
                        </div>
                        <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newPublisherToggle}>Cancel</Button>
                        <Button className="col-sm-3" variant="outline-primary" onClick={
                            this.addHandler
                        }>Submit</Button>
                    </div>
                </dd>
                <dt className="col-sm-3"> </dt>
            </>
        );
    }
}

export default NewPublisher;